// FILECONTENT_START src/common/modules/theme/AppThemeProvider.tsx
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeOptions,
  ThemeProvider,
} from "@mui/material";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { selectTheme } from "./themeSlice";

export interface AppThemeProviderProps {
  children: ReactNode;
  createTheme: (baseTheme: ThemeOptions) => any;
}
export default function AppThemeProvider({
  children,
  createTheme,
}: AppThemeProviderProps) {
  const themeBase = useSelector(selectTheme);
  //const [baseTheme, setBaseTheme] = useState({});
  const theme = createTheme(themeBase);

  /*useEffect(() => {
    setBaseTheme(themeBase);
  }, [themeBase]);*/

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

// FILECONTENT_END src/common/modules/theme/AppThemeProvider.tsx